var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeMobileBgBottom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 414,
    height: 184,
    viewBox: "0 0 414 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.489 236.739C230.471 204.316 185.207 184.306 135.262 184.306C135.262 83.299 217.189 1.41528 318.25 1.41528C368.774 1.41528 414.514 21.8819 447.628 54.9695L447.614 54.9837L468 75.3575C518.39 125.723 518.549 207.329 468.356 257.891C417.882 308.732 335.681 308.892 285.012 258.248L263.489 236.739Z",
    fill: "#00C7D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.244 333.99L187.723 312.48C155.282 279.479 135.262 234.239 135.262 184.32C135.262 134.792 154.971 89.8693 186.964 56.9375L186.975 56.9075L7.78258 236.005L7.81261 235.993C-26.4362 269.23 -47.7257 315.732 -47.7257 367.211C-47.7257 417.708 -27.2482 463.424 5.85692 496.52L5.87122 496.507L26.2558 516.881C76.6476 567.246 158.297 567.405 208.887 517.238C259.754 466.792 259.914 384.634 209.244 333.99Z",
    fill: "#841DFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-85.4258 313.376L-56.0366 305.491C-11.238 293.899 37.9521 299.181 81.1822 324.14C131.713 236.619 101.763 124.726 14.288 74.2224C-29.4432 48.9742 -79.2733 43.8484 -124.487 55.9722L-124.483 55.9898L-152.32 63.4577C-221.133 81.9145 -262.096 152.547 -243.944 221.441L-243.945 221.442C-225.691 290.718 -154.62 331.936 -85.4258 313.376Z",
    fill: "#FFBD00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMobileBgBottom);
export default __webpack_public_path__ + "static/media/home-mobile-bg-bottom.d19ed59c.svg";
export { ForwardRef as ReactComponent };